import { useSelector } from "react-redux";

import Mini from "/components/common/product/mini";
import PopupFormWrapper from "../popupFormWrapper";

const FORM_CODE = "addReview";

export default function AddReview() {
  const { data } = useSelector((state) => state.popup);

  return (
    <PopupFormWrapper
      code={FORM_CODE}
      filterField={({ CODE }) => CODE !== "form_text_115"}
      extraData={() => ({
        form_text_115: data?.id,
      })}
      successText={(r) => `Отзыв отправлен. Номер вашего отзыва #${r.success}`}
    >
      <Mini productId={data?.id} />
    </PopupFormWrapper>
  );
}
